import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const StudyMaterialCartReadSlice = createSlice({
  name: "StudyMaterialCartReadSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    StudyMaterialCartRead: (state) => {
      state.isLoading = true;
    },
    successStudyMaterialCartRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureStudyMaterialCartRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearStudyMaterialCartRead: (state) => {
      state.data = {};
    },
  },
});

export const {
  StudyMaterialCartRead,
  successStudyMaterialCartRead,
  failureStudyMaterialCartRead,
  clearStudyMaterialCartRead,
} = StudyMaterialCartReadSlice.actions;

export default StudyMaterialCartReadSlice.reducer;
